import { Component } from "react";

import { DialogContent, Dialog, DialogTitle, List, ListItem, ListItemText  }  from "@mui/material";
import Establishment from "../../controller/model/Establishment";

class DialogEstablishmentComponent extends Component {
  public state: any;
  public props: any;

  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleOpenDialog = this.handleOpenDialog.bind(this);
  }

  handleOpenDialog() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  onClose() {
    // do something
  }

  handleSelectEstablishment(establishment: Establishment) {
    this.props.handleSelectEstablishment(establishment);
  }

  render() {
    return (
      <Dialog open={this.props.isOpen} onClose={this.onClose}>
        <DialogTitle style={{ color: "#474F5E" }}>
          {" "}
          Selectionner votre établissement{" "}
          <hr style={{ border: "2px solid #474F5E" }} />
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: "#F1F1F5",
            borderBottom: "1px solid #7ABF92",
          }}
        >
          <List>
            {this.props.establishments.map((aEstablishment: Establishment) => (
              <ListItem
                key={aEstablishment.id}
                button
                onClick={() => this.handleSelectEstablishment(aEstablishment)}
                style={{ color: "#474F5E" }}
              >
                {/* <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <PersonIcon />
                                </Avatar>
                            </ListItemAvatar> */}
                <ListItemText
                  primary={
                    aEstablishment.name || "établissement sans nom"
                  }
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    );
  }
}

export default DialogEstablishmentComponent;
